import { makeStyles } from '@mui/styles';
const tradeInButtonStyles = makeStyles(({ spacing, palette: { common: { white }, }, }) => ({
    link: {
        display: 'block',
        padding: `${spacing(1)} ${spacing(2)}`,
        background: 'linear-gradient(90deg, #128089 -17.63%, #36865D 55.28%, #639C3B 100%)',
        '&:hover': {
            opacity: 0.9,
        },
        '&': {
            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
    iconLeft: {
        color: white,
    },
    container: {
        width: '100%',
        padding: `${spacing(1)} ${spacing(2)}`,
    },
    title: {
        color: white,
        display: 'inline-block',
    },
    text: {
        color: white,
        display: 'inline-block',
    },
    iconRight: {
        color: white,
    },
}), { name: 'Common_TradeInButton' });
export default tradeInButtonStyles;
//# sourceMappingURL=tradeInButton.styles.js.map